import { LogLevel } from '@azure/msal-browser';
import type { Configuration } from '@azure/msal-browser';

/**
 * MSAL configuration for Azure AD (Entra ID) authentication.
 *
 * Tenant is shared across SFC internal apps. The client id is the AVL
 * dashboard's own app registration — register a new SPA app in the Azure
 * portal and put its (Application) client id here (or read it from the
 * Vite build env).
 */

const AZURE_TENANT_ID = '4dd30c56-6534-42ea-8e25-03214368f83d';

/**
 * Vite exposes `import.meta.env.VITE_*` to the client bundle. Production
 * builds inject `VITE_AZURE_API_CLIENT_ID` at build time; local dev can set
 * it in apps/dashboard/.env.local.
 */
const CLIENT_ID =
  (import.meta.env.VITE_AZURE_API_CLIENT_ID as string | undefined) ??
  // Empty string = misconfiguration; MSAL will refuse to init and the
  // AuthProvider shows an error state instead of a blank login.
  '';

export const msalConfig: Configuration = {
  auth: {
    clientId: CLIENT_ID,
    authority: `https://login.microsoftonline.com/${AZURE_TENANT_ID}`,
    redirectUri: typeof window !== 'undefined' ? window.location.origin : '/',
    postLogoutRedirectUri: typeof window !== 'undefined' ? window.location.origin : '/',
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
      logLevel: LogLevel.Warning,
    },
  },
};

/** Scopes the SPA requests. User.Read yields a Microsoft Graph-audience token. */
export const loginRequest = {
  scopes: ['User.Read'],
};
